import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CONSTANTS from "../constants/constants";


export default function useSearchData() {
  let [ searchParams, setSearchParams ] = useSearchParams();
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(null);
  const [stories, setStories] = useState(null);
  const [itemCount, setItemCount] = useState(2000);

  const petType = searchParams.get('petType') || 0;
  const breed = searchParams.get('breed') || 0;
  const dietaryGoal = searchParams.get('dietaryGoal') || 0;
  const currentPage = searchParams.get('page') || 0;
  useEffect(() => {
    setLoading(true);
    window.scroll(0,0);
    fetch(`${CONSTANTS.baseUrl}api/truestories/search?petTypeId=${petType}&breedId=${breed}&dietaryGoalsId=${dietaryGoal}&page=${currentPage}`)
    .catch(err => setError(err))
    .then(res => res.json())
    .then(response => {
      setStories(response.data)
      setItemCount(response.count)
      setLoading(false)
    });
  }, [ petType, breed, dietaryGoal, currentPage ]);

  return [ loading, error, { stories, currentPage, itemCount, petType, breed, dietaryGoal } ];
}
